const workRouter = [
  {
      path: "list-work",
      name: "work",
      component: () => import("@/views/admin/work"),
      default: true,
      meta: {
          model: "work",
          // requiresAuth: true,
      },
  },
  {
      path: "list-work/add",
      name: "addWork",
      component: () => import("@/views/admin/work/function"),
      default: true,
      meta: {
          model: "work",
          // requiresAuth: true,
      },
  },
  {
      path: "list-work/edit/:id",
      name: "editWork",
      component: () => import("@/views/admin/work/function"),
      default: true,
      meta: {
          model: "work",
          // requiresAuth: true,
      },
  },
];
export default workRouter;